import { render, staticRenderFns } from "./airline-view.vue?vue&type=template&id=37edb398"
import script from "./airline-view.vue?vue&type=script&lang=js"
export * from "./airline-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports